import { ScoringSectionsComponent } from './scoring-sections.component';

export default angular
  .module('sfMobile.components.scoring-sections', [
    'sfMobile.components.scoring-stats',
    'sfMobile.components.scoring-prev-stats',
    'sfMobile.components.progressBar',
  ])
  .component('sfScoringSections', ScoringSectionsComponent).name;
